export default __webpack_public_path__ + "static/media/pictogramProcess40.cccfea74.svg";